import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PartnerDashboardsService from 'tio-employee/services/partner-dashboards';
import type RouterService from '@ember/routing/router';

export default class AuthenticatedAdminReportsIndexRoute extends Route {
  @service declare partnerDashboards: PartnerDashboardsService;
  @service declare router: RouterService;

  async model() {
    return this.partnerDashboards.loadAndFilterReportsForPartner();
  }

  /** @param model the partner's QuickSight dashboards, as loaded above */
  afterModel(model: { id: string }[]) {
    // A partner with a single dashboard has no listing worth showing.
    if (model.length === 1) {
      this.router.transitionTo('authenticated.admin.reports.show', model[0]?.id ?? '');
    }
  }
}
